// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header{position:fixed;top:0;right:0;left:0;z-index:10;height:50px;padding-right:50px;padding-left:50px;line-height:50px;text-align:right}.nav-iconSet-login{color:#333;cursor:pointer}.wrapper{height:100%}.content-wrapper{position:relative;height:100%;overflow-y:auto}", ""]);
// Exports
module.exports = exports;
